module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/book-pre-cover-txt--pt.cc842858.png";